module.exports = __webpack_public_path__ + "static/media/igauge.46b1fb04.png";